import { GLOBALS } from '../globals'
import { createTextVariantComponents } from '../setup-factories'

export const { TextStandard } = createTextVariantComponents({
  Standard: {
    font: {
      family: GLOBALS.font.default.family,
      weight: 400,
      size: '14px',
      lineHeight: '24px',
      color: GLOBALS.color.grey[500]
    }
  }
})
